<template>
  <div class="wlx-signUp-receipt-wrapper">
    <div class="basic-head-main" :style="{backgroundImage:'url('+headBg+')'}">
      <div class="basic-head-con">
        <div class="head-title-con clearfix">
          <div class="fl basic-book-img-con">
            <img src="~assets/images/basic-book-img.png" alt />
          </div>
          <div class="fr head-title-word">
            <p class="p-title-1">报名回执表</p>
            <p class="p-title-2 p-title-2-1">——北京中物联物流采购培训中心</p>
          </div>
        </div>
      </div>
    </div>
    <div class="signUp-receipt-content">
      <table class="sign-table-1" border="0" cellspacing="0" cellpadding="0">
        <tr>
          <td colspan="2" class="sign-table-label" width="120px">
            <span class="sp-must-tip">*</span> 申请人姓名
          </td>
          <td colspan="2">
            <el-input v-model="hostName" disabled></el-input>
          </td>
          <td colspan="2" class="sign-table-label" width="120px">
            <span class="sp-must-tip">*</span> 申请人手机号
          </td>
          <td colspan="2">
            <el-input v-model="hostPhoneNum" disabled></el-input>
          </td>
          <td colspan="2" class="sign-table-label" width="120px">
            <span class="sp-must-tip">*</span> 付款方式
          </td>
          <td colspan="2">
            <el-select v-model="payWay" placeholder="请选择付款方式" disabled>
              <el-option label="公对公汇款" :value="1"></el-option>
              <el-option label="现场刷卡" :value="2"></el-option>
              <el-option label="微信支付（线上培训）" :value="3"></el-option>
            </el-select>
          </td>
        </tr>
        <tr>
          <td colspan="2" class="sign-table-label" width="120px">
            <span class="sp-must-tip">*</span>入住酒店
          </td>
          <td colspan="6">
            <el-input v-model="hotel" disabled></el-input>
          </td>
          <td colspan="2" class="sign-table-label">
            <span class="sp-must-tip">*</span>到达时间
          </td>
          <td colspan="2">
            <el-date-picker disabled v-model="ArriveDate" type="datetime" placeholder="选择到达时间"></el-date-picker>
          </td>
        </tr>
        <tr>
          <td colspan="2" class="sign-table-label" width="120px">
            <span class="sp-must-tip">*</span>单位名称
          </td>
          <td colspan="10">
            <el-input v-model="unitName" disabled></el-input>
          </td>
        </tr>
        <tr>
          <td colspan="2" class="sign-table-label">
            <span class="sp-must-tip">*</span>地址
          </td>
          <td colspan="4">
            <el-input v-model="address" disabled></el-input>
          </td>
          <td colspan="2" class="sign-table-label">
            <span class="sp-must-tip">*</span>邮编
          </td>
          <td colspan="4">
            <el-input v-model="zipCode" disabled></el-input>
          </td>
        </tr>
        <tr>
          <td colspan="12" class="sign-table-label">开票信息(本次会议的参会费一律开增值税普票)</td>
        </tr>
        <tr>
          <td colspan="2" class="sign-table-label">
            <span class="sp-must-tip">*</span>发票抬头
          </td>
          <td colspan="4">
            <el-input v-model="invoice" disabled></el-input>
          </td>
          <td colspan="2" class="sign-table-label">
            <span class="sp-must-tip">*</span>纳税人识别号
          </td>
          <td colspan="4">
            <el-input v-model="taxesNum" disabled></el-input>
          </td>
        </tr>
        <tr>
          <td colspan="2" class="sign-table-label">
            <span class="sp-must-tip">*</span> 开票项目选择
          </td>
          <td colspan="10">
            <div class="sign-up-check-con">
              <el-checkbox-group v-model="checkList" disabled>
                <el-checkbox label="会议费"></el-checkbox>
                <el-checkbox label="会务费"></el-checkbox>
                <el-checkbox label="培训费"></el-checkbox>
              </el-checkbox-group>
            </div>
          </td>
        </tr>
        <tr>
          <td colspan="2" class="sign-table-label" width="120px">备注</td>
          <td colspan="10">
            <el-input v-model="remarks" disabled></el-input>
          </td>
        </tr>
      </table>
      <el-table class="sign-table-1" :data="tableData">
        <el-table-column prop="name" label="姓名" width="120px" align="center">
          <template slot-scope="scope">
            <el-input v-model="scope.row.name" size="small" disabled></el-input>
          </template>
        </el-table-column>
        <el-table-column prop="sex" label="性别" align="center" width="104px">
          <template slot-scope="scope">
            <el-input v-model="scope.row.sex" size="small" disabled></el-input>
          </template>
        </el-table-column>
        <el-table-column prop="post" label="职务" align="center" width="250px">
          <template slot-scope="scope">
            <el-input v-model="scope.row.post" size="small" disabled></el-input>
          </template>
        </el-table-column>
        <!-- <el-table-column prop="IDNum" label="身份证号" align="center" width="159px">
          <template slot-scope="scope">
            <el-input v-model="scope.row.IDNum" size="small" disabled></el-input>
          </template>
        </el-table-column>-->
        <el-table-column prop="phoneNum" label="移动电话" align="center" width="232px">
          <template slot-scope="scope">
            <el-input v-model="scope.row.phoneNum" size="small" disabled></el-input>
          </template>
        </el-table-column>
        <el-table-column prop="email" label="E-mail" align="center">
          <template slot-scope="scope">
            <el-input v-model="scope.row.email" size="small" disabled></el-input>
          </template>
        </el-table-column>
        <el-table-column prop="living" label="单/合住" align="center" width="120px">
          <template slot-scope="scope">
            <el-input v-model="scope.row.living" size="small" disabled></el-input>
          </template>
        </el-table-column>
      </el-table>
      <div class="p-sign-up-tip">
        <p>参会说明：</p>
        <p>
          1、报到时间：2019年9月20日8:00-22:00 会议时间：9月21-22日
          报到地点：南昌融创万达嘉华酒店大堂报到处
          地址：江西省南昌市红谷滩新区南龙蟠街333号
        </p>
        <p>2、请尽量提前报名并提前汇款，每个酒店房间的数量有限，我们将按到款及报到的前后顺序安排，若未经报名前来参会者，会议不能确保住房接待。</p>
      </div>
    </div>
    <div class="back-to-system">
      <el-button type="primary" @click="backSystem">关闭</el-button>
      <el-button type="danger" @click="deleteEnroll">删除</el-button>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      hostName: "",
      hostPhoneNum: "",
      payWay: "",
      hotel: "",
      ArriveDate: "", // 到达时间
      unitName: "",
      address: "",
      remarks: "",
      zipCode: "",
      invoice: "",
      taxesNum: "",
      tableData: [],
      headBg: require("assets/images/wlx-baic-bg-img.png"),
      checkList: []
    };
  },
  props: {
    signUpId: {
      type: String,
      default: ""
    },
    activityId: {
      type: String,
      default: ""
    }
  },
  created() {
    this.getSignUpDetail();
  },
  methods: {
    getSignUpDetail() {
      this.$http
        .post("/api/XOrg/SpecialActivity/getMeetingEnrollInfo", {
          id: this.signUpId
        })
        .then(res => {
          if (res.code > 0) {
            this.hostName = res.info.CreateDisplayName;
            this.hostPhoneNum = res.info.CreateUserName;
            this.payWay = res.info.PaymentType == 0 ? "" : res.info.PaymentType;
            this.hotel = res.info.Hotel;
            this.ArriveDate = res.info.ArriveDate;
            this.unitName = res.info.CompanyName;
            this.address = res.info.Address;
            this.zipCode = res.info.ZipCode;
            this.invoice = res.info.Invoice;
            this.taxesNum = res.info.TaxNumber;
            this.remarks = res.info.Note;
            this.tableData = JSON.parse(res.info.EnterPerson);
            this.checkList = JSON.parse(res.info.InvoiceItem);
          }
        });
    },
    deleteEnroll() {
      var that = this;
      this.$confirm("此操作将永久删除该报名记录, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          that.$http
            .post("/api/XOrg/MeetingEnroll/deleteEnroll", {
              id: this.signUpId
            })
            .then(res => {
              if (res.code > 0) {
                that.$message.success(res.msg);
                that.backSystem();
              } else {
                that.$message.warning(res.msg);
              }
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除"
          });
        });
    },
    backSystem() {
      // this.$router.push({
      //   name:'basicInfo'
      // });
      this.$router.push({
        name: "MeetingEnrollManager",
        params: {
          activityId: this.activityId
        }
      });
      // this.$router.go(-1);
    }
  }
};
</script>

<style lang="scss">
.wlx-signUp-receipt-wrapper {
  .basic-head-main {
    height: 706px;
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center top;
    .basic-head-con {
      margin: 0 auto;
      width: 1000px;
    }
    .head-logo-con {
      padding: 26px 0 0 26px;
    }
    .logo-img-val {
      height: 40px;
    }
    .head-title-con {
      position: relative;
      padding-top: 40px;
    }
    .basic-book-img-con {
      margin-left: 10px;
    }
    .head-title-word {
      position: absolute;
      right: 0;
      top: 80px;
      z-index: 100;
      color: #fff;
    }
    .p-title-1 {
      font-size: 55px;
      font-weight: bold;
      text-align: center;
    }
    .p-title-2-1 {
      margin-top: 50px;
      text-align: right;
      font-size: 20px;
    }
  }
  .signUp-receipt-content {
    margin: -325px auto 0;
    padding-top: 50px;
    width: 1100px;
    min-height: 400px;
    background: #fff;
  }
  .sign-up-h2 {
    padding: 30px 0;
    text-align: center;
  }
  table,
  .el-table {
    margin: 0 auto;
    width: 1060px;
    border-right: 1px solid #999;
    border-bottom: 1px solid #999;
    table-layout: fixed;
    word-break: break-all;
    background: #f0f0f0;
  }
  .sign-table-label {
    color: #000;
    font-weight: 600;
    font-size: 16px;
  }
  .el-table th {
    padding: 8px 0;
    border-left: 1px solid #999;
    color: #000;
    background: #f0f0f0;
    font-size: 16px;
  }
  .el-table__header {
    border-bottom: none;
  }
  table td {
    border-left: 1px solid #999;
    border-top: 1px solid #999;
    text-align: center;
  }
  .el-textarea__inner,
  .el-input__inner {
    border: none;
    font-size: 16px;
    color: #000;
  }
  .el-input.is-disabled .el-input__inner {
    color: #666;
  }
  .sign-table-1 {
    tr td {
      height: 40px;
    }
  }
  .add-table-tr-btn {
    padding: 15px 0;
    text-align: center;
    color: #2d82ff;
    cursor: pointer;
  }
  .p-sign-up-tip {
    padding: 10px 30px;
    font-size: 16px;
    p {
      margin-bottom: 10px;
    }
  }
  .submit-btn {
    padding: 20px 0;
    text-align: center;
  }
  .back-to-system {
    padding: 20px 0;
    text-align: center;
  }
}
</style>
